/** Default public byline for BOOTH Articles. */
export const BLOG_AUTHOR = {
  name: "Paul Panama",
  role: "Marketing & Barbershop Journalist",
  publication: "BOOTH Articles",
  initials: "PP",
  avatar: "booth",
} as const

/** Founder byline — same booth mark; every BOOTH byline carries it now. */
export const BLOG_FOUNDER = {
  name: "Eduardo Ramos",
  role: "Founder",
  publication: "BOOTH Articles",
  initials: "ER",
  avatar: "booth",
} as const

export type BlogAuthorAvatar = "initials" | "booth"

export type BlogAuthor = {
  name: string
  role: string
  publication?: string
  initials: string
  avatar?: BlogAuthorAvatar
}

export type BlogArticleAuthor = "editor" | "founder"

const AUTHORS: Record<BlogArticleAuthor, BlogAuthor> = {
  editor: BLOG_AUTHOR,
  founder: BLOG_FOUNDER,
}

export function resolveBlogAuthor(key?: BlogArticleAuthor): BlogAuthor {
  return AUTHORS[key ?? "editor"]
}
